// extracted by mini-css-extract-plugin
export var chip = "_45-9";
export var chipLabel = "_45-a";
export var close = "_45-7";
export var closeIcon = "_45-8";
export var error = "_45-6";
export var infoTooltip = "_45-2";
export var innerContainer = "_45-1";
export var input = "_45-b";
export var medium = "_45-5";
export var outerContainer = "_45-0";
export var small = "_45-4";
export var xSmall = "_45-3";